import { useEffect, useState } from "react";
import axios from "axios";
import { CalendarX2, ChevronDown, ChevronRight } from "lucide-react";
import { API } from "../../context/AuthContext";
import { UndatedList } from "../portal/DeadlinesTab";

export default function UndatedSection({ caseId, events, canEdit, onChanged, onSource }) {
  const [facts, setFacts] = useState([]);
  const [open, setOpen] = useState(false);

  const load = () => caseId && axios.get(`${API}/cases/${caseId}/undated`).then((r) => setFacts(r.data)).catch(() => setFacts([]));
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { load(); }, [caseId, events.length]);

  if (!facts.length) return null;
  return (
    <div className="mt-6 border border-amber-500/25 rounded-xl p-4 bg-amber-500/5" data-testid="undated-section">
      <button onClick={() => setOpen((o) => !o)} className="flex items-center gap-2 w-full text-left" data-testid="undated-section-toggle">
        <CalendarX2 className="w-4 h-4 text-amber-400" />
        <span className="text-xs font-bold uppercase tracking-wide text-amber-300">Undated / Needs Review</span>
        <span className="text-[10px] font-mono text-amber-200/70">{facts.length} fact{facts.length === 1 ? "" : "s"} without an unambiguous date</span>
        {open ? <ChevronDown className="w-4 h-4 text-amber-300 ml-auto" /> : <ChevronRight className="w-4 h-4 text-amber-300 ml-auto" />}
      </button>
      {open && (
        <div className="mt-3">
          <UndatedList facts={facts} canEdit={canEdit} showDoc onSource={onSource} onChanged={() => { load(); onChanged(); }} />
        </div>
      )}
    </div>
  );
}
